export const bhpButtonSx = {

    backgroundColor: '#e65400',
    color: 'white',
    fontWeight: 'bold',
    textTransform: 'none',
    '&:hover': {
        backgroundColor: '#cc4700'
    },
    "&.Mui-disabled": {
        background: "#eaeaea",
        color: "#c0c0c0"
    }

};

